module.exports = __webpack_public_path__ + "static/assets/fecac138d9804141503e2838d1554e1e.svg";